import React, { FC, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EmailConfirmation } from "components/EmailConfirmation/EmailConfirmation";
import "./SignUpPage.styles.sass";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "../../components/shared/Button/Button";
import { useAppDispatch, useAppSelector } from "../../toolkit/hooks";
import { signUp } from "../../toolkit/profile/profile.thunks";
import { MyInput } from "../StepPages/StepTwo/MyInput/MyInput";
import { ClearError } from "toolkit/profile/profile.slice";

export const SignUpPage: FC = () => {
	const [name, setName] = useState<string>("");
	const [surname, setSurname] = useState<string>("");
	const [patronymic, setPatronymic] = useState<string>("");
	const [email, setEmail] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [repeatPassword, setRepeatPassword] = useState<string>("");
	const [successfullySubmit] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [submitError, setSubmitError] = useState<boolean>(false);
	const { authed, error } = useAppSelector((state) => state.profile);
	const [repeatedPasswordCorrect, setRepeatedPasswordCorrect] = useState<boolean>(true);
	const [passwordCorrect, setPasswordCorrect] = useState<boolean>(true);

	const emailChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (error.status) dispatch(ClearError());
		setEmail(e.target.value);
	};

	const passwordChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPassword(e.target.value);
	};

	const signUpHandler = (e: React.FormEvent<HTMLFormElement>): void => {
		e.preventDefault();
		comparePasswords();
		if (
			!name.trim() ||
			!surname.trim() ||
			!patronymic.trim() ||
			!validateEmail() ||
			!validatePassword() ||
			!validateRepeatPassword()
		) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			// setSuccessfullySubmit(true);
			dispatch(signUp({ email, password, name, surname, patronymic }));
		}
	};

	const comparePasswords = () => {
		if (password !== repeatPassword) setRepeatedPasswordCorrect(false);
		else setRepeatedPasswordCorrect(true);
	};

	const checkPassword = () => {
		if (validatePassword()) setPasswordCorrect(true);
		else setPasswordCorrect(false);
	};

	useEffect(() => {
		if (repeatedPasswordCorrect) return;
		comparePasswords();
		//eslint-disable-next-line
	}, [password, repeatPassword, repeatedPasswordCorrect]);

	useEffect(() => {
		if (authed) navigate("/organizations");
		dispatch(ClearError());
		//eslint-disable-next-line
	}, [authed]);

	const validateRepeatPassword = (): boolean => {
		const regExp = "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$";
		if (!repeatPassword.match(regExp) || password !== repeatPassword) return false;
		return true;
	};

	const validatePassword = (): boolean => {
		const regExp = "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$";
		if (!password.match(regExp)) return false;
		return true;
	};

	const validateEmail = (): boolean => {
		const regExp = "^[_A-Za-z0-9-+]+(.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,})$";
		if (!email.match(regExp) || !email.includes(".") || email.includes(" ")) return false;
		// if (!email || email.includes(' ') || !email.includes('@') || !email.includes('.')) return false
		return true;
	};

	return (
		<>
			{!successfullySubmit && (
				<div className="authentication signup">
					<h3 className="authentication-title signup">Создание профиля</h3>
					<form onSubmit={signUpHandler} className="authentication-form signup">
						<MyInput
							className="authentication-form-item"
							name="Фамилия"
							placeholder="Константинопольский"
							value={surname}
							set={(e) => setSurname(e.target.value)}
							required={true}
							condition={submitError && !surname.trim()}
						/>
						<MyInput
							className="authentication-form-item"
							name="Имя"
							placeholder="Константин"
							value={name}
							set={(e) => setName(e.target.value)}
							required={true}
							condition={submitError && !name.trim()}
						/>
						<MyInput
							className="authentication-form-item"
							name="Отчество"
							placeholder="Константинович"
							value={patronymic}
							set={(e) => setPatronymic(e.target.value)}
							required={true}
							condition={submitError && !patronymic.trim()}
						/>
						<MyInput
							className="authentication-form-item"
							name="Почта"
							placeholder="address@domain.ru"
							value={email}
							set={(e) => emailChangeHandler(e)}
							required={true}
							condition={(submitError && !validateEmail()) || error?.status === 409}
							warning={{ text: error.message, condition: error?.status === 409 }}
						/>
						<MyInput
							className="authentication-form-item"
							name="Пароль"
							placeholder="**********"
							value={password}
							set={(e) => passwordChangeHandler(e)}
							description="Пароль должен состоять минимум из 8 символов, должна быть
              минимум одна заглавная буква и не меньше одной цифры"
							type="password"
							required={true}
							condition={(submitError || !passwordCorrect) && !validatePassword()}
							warning={{
								text: "Не соблюдены условия",
								condition: (submitError || !passwordCorrect) && !validatePassword(),
							}}
							blur={checkPassword}
						/>
						<MyInput
							className="authentication-form-item"
							name="Подтверждение пароля"
							placeholder="**********"
							value={repeatPassword}
							set={(e) => setRepeatPassword(e.target.value)}
							type="password"
							required={true}
							condition={(submitError || !repeatedPasswordCorrect) && !validateRepeatPassword()}
							warning={{ text: "Пароли не совпадают", condition: !repeatedPasswordCorrect }}
							blur={comparePasswords}
						/>
						<div className="account-exists-wrp">
							<Button to="/login" variant={BUTTON_VARIANTS.TEXT}>
								У меня уже есть аккаунт
							</Button>
						</div>
						<div className="authentication-form-btns">
							<Button full>Готово</Button>
						</div>
					</form>
				</div>
			)}
			{successfullySubmit && <EmailConfirmation email={email} />}
		</>
	);
};
